import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";

import {PartnershipSchema, partnershipSchema} from "@/schemas/partnership.schema";
import {companyOptions, titleOptions} from "@/constants/common";
import {ContactUsFormProps} from "@/constants/type/props";
import {useFormSubmit} from "@/hooks/useFormSubmit";

import FormWrapper from "./common/FormWrapper";
import FormField from "./common/FormField";


export default function PartnershipForm({onSuccess}: ContactUsFormProps) {
  const {handleSubmit, control, formState: {isSubmitting}, reset} = useForm<PartnershipSchema>({
    resolver: yupResolver(partnershipSchema),
    mode: "onSubmit",
  });

  const {errorMessage, handleSubmit: onSubmit} = useFormSubmit({
    contactType: "partnership",
    onSuccess,
    reset,
  });

  const description = (
    <p>
      Does your facility conduct tests or administer vaccines? Join our network.
      Please email to <a href="mailto:contact@further.network">contact@further.network</a> for
      general inquiries.
    </p>
  );

  return (
    <FormWrapper
      title="Partnership"
      description={description}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
    >
      <div className="row d-flex">
        <FormField
          name="companyType"
          control={control}
          label="Company Type"
          type="select"
          options={companyOptions}
          className="col-md-6"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="companyName"
          control={control}
          label="Company Name"
          type="text"
          className="col-md-6"
        />
        <FormField
          name="websiteUrl"
          control={control}
          label="Website Url"
          type="text"
          className="col-md-6"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="title"
          control={control}
          label="Title"
          type="select"
          options={titleOptions}
          className="col-md-2"
        />
        <FormField
          name="name"
          control={control}
          label="Contact Person Name"
          type="text"
          className="col-md-4"
        />
        <FormField
          name="jobTitle"
          control={control}
          label="Job Title"
          type="text"
          className="col-md-6"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="email"
          control={control}
          label="Email"
          type="email"
          className="col-md-3"
        />
        <FormField
          name="phone"
          control={control}
          label="Phone"
          type="phone"
          className="col-md-3"
        />
        <FormField
          name="country"
          control={control}
          label="Country"
          type="country"
          className="col-md-3"
        />
        <FormField
          name="city"
          control={control}
          label="City"
          type="text"
          className="col-md-3"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="subject"
          control={control}
          label="Subject"
          type="text"
          className="col-md-6"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="comments"
          control={control}
          label="Comments"
          type="textarea"
          className="col-md-6"
          rows={5}
        />
      </div>
    </FormWrapper>
  );
}
